import { PluralizationRule } from 'vue-i18n';

/*
  Example:
  car: '0 машин | {n} машина | {n} машины | {n} машин',
  banana: 'нет бананов | {n} банан | {n} банана | {n} бананов'
 */
export const russianPluralizationRule: PluralizationRule = (choice) => {
  if (choice === 0) {
    return 0; // Форма для нуля.
  }

  const teen = choice % 100 > 10 && choice % 100 < 20; // Обрабатывает исключение 10–19.
  const endsWithOne = choice % 10 === 1;
  const endsWithTwoToFour = choice % 10 >= 2 && choice % 10 <= 4;

  if (!teen && endsWithOne) {
    return 1; // Форма на "-1" (1машина, 1 банан).
  }

  if (!teen && endsWithTwoToFour) {
    return 2; // Форма для чисел "-2, -3, -4" (2 машины, 3 банана).
  }

  return 3; // Для остальных случаев (5 машин, 11 машин и т.д.).
};
